import { COLORS } from 'lib/theme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PieChart } from 'react-minimal-pie-chart';
import React from 'react';

export default function GaugeChart({ data, options }) {
  let degree = 0;
  switch (options.level) {
    case 'sparse':
      degree = 'rotate(120, 50, 50)';
      break;
    case 'normal':
      degree = 'rotate(170, 50, 50)';
      break;
    case 'crowded':
      degree = 'rotate(220, 50, 50)';
      break;
    case 'congested':
      degree = 'rotate(270, 50, 50)';
      break;
    default:
      break;
  }
  return (
    <PieChart
      data={data}
      startAngle={180}
      lengthAngle={180}
      lineWidth={35}
      radius={38}
      background={COLORS.light}
      {...options}>
      <text
        x={16}
        y="60%"
        textAnchor="middle"
        fill={COLORS.light}
        style={{ fontSize: 8 }}>
        여유
      </text>
      <FontAwesomeIcon
        id="icon"
        icon="map-marker-alt"
        symbol="marker"
        color={COLORS.accent}
      />
      <svg>
        <g fill={options.fill}>
          <circle
            cx={50}
            cy={50}
            r={13}
            fill={COLORS.white}
            fillOpacity="0.9"
          />
          <circle cx={50} cy={50} r={9} fill={options.fill} fillOpacity="0.9" />
          <use
            x={44}
            y={45}
            href="#marker"
            width={12}
            height={12}
            fill={COLORS.white}
            stroke={COLORS.white}
            strokeWidth={4}
            transform={degree}
          />
        </g>
      </svg>
      <text
        x="80%"
        y="60%"
        textAnchor="middle"
        fill={COLORS.light}
        style={{ fontSize: 8 }}>
        <tspan>매우</tspan>
        <tspan x="80%" dy={9.5}>
          혼잡
        </tspan>
      </text>
    </PieChart>
  );
}
